import { Event } from "../../../Global/Base/Events";
import { ContainerToolbarControl } from "../../UI/UI/Toolbar/ToolbarControl";
import { IAction } from "./IAction";

export interface INodeAction extends IAction {
    //#region Fields
    actions: Array<IAction>;
    parentAction: ContainerToolbarControl;
    readonly ctrlID: string;

    //#endregion Fields

    //#region Events
    itemAdded: Event<INodeAction, IAction>;
    itemRemoved: Event<INodeAction, IAction>;
    //#endregion Events

    addAction(action: IAction): void;
    removeAction(action: IAction): void;
}

export class INodeAction {
    private static _properties = ["actions", "parentAction", "itemAdded", "itemRemoved"];
    private static _methods = ["addAction", "removeAction"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
